import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=13d353ca&scoped=true&"
import script from "./FileDrop.js?vue&type=script&lang=js&"
export * from "./FileDrop.js?vue&type=script&lang=js&"
import style0 from "./FileDrop.scoped.scss?vue&type=style&index=0&id=13d353ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d353ca",
  null
  
)

export default component.exports